import axios from 'axios'
import errorParser from '@/utils/error-parser'

// Chart observations on sensor series — documentation/features/consumers.md
export default {
  listForSensor (sensorId, fromMs, untilMs, systempart, valuetype) {
    const params = { from: fromMs, until: untilMs }
    if (systempart != null) params.systempart = systempart
    if (valuetype != null) params.valuetype = valuetype
    return new Promise((resolve, reject) => {
      axios.get('/cdcsensors/' + sensorId + '/observations', { params }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  addObservation (sensorId, detail) {
    // detail: { systempart, valuetype, observedat (ms), kind, delta, value, applianceid, note }
    return new Promise((resolve, reject) => {
      axios.post('/cdcsensors/' + sensorId + '/observations', detail).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  patchObservation (observationId, patch) {
    return new Promise((resolve, reject) => {
      axios.patch('/observations/' + observationId, patch).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  deleteObservation (observationId) {
    return new Promise((resolve, reject) => {
      axios.delete('/observations/' + observationId).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  propose (sensorId, systempart, valuetype, timestampMs) {
    return new Promise((resolve, reject) => {
      axios.get('/cdcsensors/' + sensorId + '/observations/propose', { params: { systempart, valuetype, timestamp: timestampMs } }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
